import { ZapierAppRow } from '../components/ZapierAppRow';
import type { AppRow } from '../type/AppRow';

export const zapierAppRow: AppRow = {
  key: 'zapier',
  name: 'Zapier',
  AppComponent: ZapierAppRow,
};
